<script setup>
import {useStore} from "vuex";
import {ref, computed, onMounted} from "vue";
import axios from "axios";

//----------------------------------------------------------------------

const store = useStore()
const isLoading = ref(false)
const teams = ref([])
// команды пользвателя после применения прав на доступ (в этой версии нет)
const userTeams = ref([])
// запрос на role делаем каждый раз, не только при авторизации
const userData = ref([])
// результаты команд
const results = ref(0)
// количество критериев в списке, определяем в ответе results
// const criterias = ref(0)

//----------------------------------------------------------------------

onMounted( ()=>{
  try {
    init()
  } catch (err) {
    alert ('APPLICATION ERROR')
  }
})

//----------------------------------------------------------------------

const init = async () => {

  isLoading.value = true
  store.commit('menuModule/initMenu')

  const urlData = process.env.VUE_APP_ADMIN_URL + "/api/userData.php"
  const urlTeams = process.env.VUE_APP_URL + "/api/teams"
  const urlResult = process.env.VUE_APP_ADMIN_URL + "/api/results.php"

  // userId.value получен при авторизации
  // userData информация о пользователе, возможно изменение role
  // скажет если где то надо поменять права
  // framework/cash/data
  // console.log(`${urlTeams}/${token.value}/${userData.value['role']}`)

  await axios
      .get(`${urlData}?token=${token.value}&id=${userId.value}`)
      .then(response => (userData.value = response.data))

  // команды, который оценивает user и результаты
  if (userData.value) {
    await axios
        .get(`${urlTeams}/${token.value}/${userData.value['role']}`)
        .then(response => (teams.value = response.data))
        .then(
            await axios
                .get(`${urlResult}?token=${token.value}&id=${userId.value}&role=${userData.value['role']}`)
                .then(response => (results.value = response.data))
        )

    //console.log(userData.value['name'])
    //обновить данные о пользователе
    store.commit('userModule/setUserData', userData.value)
  }

  //console.log( `${urlTeams}/${token.value}/${userData.value['role']}` )

  if (teams.value.data.length === 0) {

    // команд нет
    setTimeout(() => isLoading.value = false, 3000);

  } else {

    // команды загружены
    isLoading.value = false
    // для удобства и осталось от старой версии
    userTeams.value = teams.value.data
    // запишем полный список команд в стор
    // для работы вкладок
    store.commit('teamsModule/setTeams', userTeams.value)
  }
}

// рейтинг каждой команды
// суммирование баллов
// только для меня && item['userId'] === userData.value['id']
const createRating = (teamId) => {
  let criteriaSum = 0;
  results.value.forEach((item) => {
    if (+item['teamId'] === teamId && item['userId'] === userData.value['id']){
        criteriaSum += +item['result']
    }
  });
  //criteriaSum = '?'
  return criteriaSum
}

// проверяем, есть оценки у команды или нет
// кроме суперадмина role=100
const testTeam = (teamId, userId) => {
  if (userData.value['role'] === 100){
    return true
  } else {
    let complete = false
    results.value.forEach((item) => {
      if (+item['teamId'] === +teamId && +item['userId'] === +userId) {
        complete = true
      }
    });
    return complete
  }
}

//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
const userId = computed( () => {return store.getters['authModule/userId']})
</script>

<template>

    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col"><h3>Команды <span v-if="userTeams.length > 0">({{ userTeams.length }})</span></h3></div>
        </div>
      </div>
    </section>

    <!-- Ссылку формируем как /id команды/id задачи для варианта, что критерии персональные по задачам -->

    <section class="content mt-2">
      <div class="container-fluid">
        <div class="row" v-if="userTeams">
          <div
              v-for="(team,index) in userTeams"
              :key="index"
              class=" col-md-6 col-sm-12 mb-2"
          >
            <router-link
                :to="'/team/' + team['original']['team_id'] + '/' + team['original']['TaskId']"
                class="card-link"
            >
              <div class="card">
                <div :class="['card-header', testTeam(team['original']['team_id'], userId) ? 'bg-completed' : 'bg-no-completed']">
                  <strong>{{  team['original']['team'] }}</strong>
                </div>
                <div class="card-body" style="min-height: 180px">
                  <div
                      class="team-rating"
                  >{{ createRating( team['original']['team_id'] ) }}</div>

                  <strong>Задача:</strong><br>
                  {{ team['original']['Task'] }}
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <div
              v-if="isLoading"
              class="spinner-border text-primary m-4" role="status"
          ></div>
        </div>
      </div>

    </section>

</template>
<style scoped>
.bg-completed{
  background-color: #80b5d3;
  color: #fff;
}
.bg-no-completed{
  background-color: #ff5858;
  color: #fff;
}
.team-rating {
  display: flex;
  align-items:center;
  justify-content:center;
  text-align:center;
  width:75px;
  height:75px;
  border:3px solid #ff5858;
  border-radius:50%;
  margin: 0 auto 10px auto;
  color: #ff5858;
  font-size: 24px;
  font-weight: bold;
}
.team-rating-empty {
  display: flex;
  align-items:center;
  justify-content:center;
  text-align:center;
  width:75px;
  height:75px;
  border:3px solid #c7c7c7;
  border-radius:50%;
  margin: 0 auto 10px auto;
  color: #c7c7c7;
  font-size: 24px;
  font-weight: bold;
}
.result {
  font-size: 21px;
}

</style>